import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  cancel: {
    defaultMessage: 'Cancel',
    description: 'Abandon the current action and close without saving',
  },
  save: {
    defaultMessage: 'Save',
    // Keep this descriptor's identity to reuse every shipped translation.
    description: 'Save button',
  },
});

export default messages;
